import { ThunkAction } from 'redux-thunk';
import { AnyAction } from 'redux';
import * as stApi from '../api/station-tools-api';
import { RootState } from './reducers';
import { User } from '../model/types';
import { makeId } from '../helpers/utils';

export const USERS_GET = 'USERS_GET';
export const USERS_CREATE = 'USERS_CREATE';
export const USERS_DELETE = 'USERS_DELETE';
export const USERS_UPDATE = 'USERS_UPDATE';

// TODO: create/update/delete are local-only - they mutate the Redux store
// and are lost on reload. The API has no user-write endpoints; it only
// serves GET /users. This matches the original pre-migration behaviour and
// needs real endpoints before the editor can persist anything.

// TODO remove when users are implemented
// const users = [
//   {
//     _id: 'ABBC123',
//     firstName: 'Vladimir',
//     lastName: 'Kotcherechenko',
//     email: 'test@test.test',
//     phone: 1234345454,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Test designation',
//     department: 'Test department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC124',
//     firstName: 'Another',
//     lastName: 'Test',
//     email: 'hey@test.test',
//     phone: 257257257,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Another designation',
//     department: 'Another department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC125',
//     firstName: 'Test',
//     lastName: 'Test',
//     email: 'test@test.test',
//     phone: 1234345454,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Test designation',
//     department: 'Test department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC126',
//     firstName: 'Another',
//     lastName: 'Test',
//     email: 'hey@test.test',
//     phone: 257257257,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Another designation',
//     department: 'Another department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC127',
//     firstName: 'Test',
//     lastName: 'Test',
//     email: 'test@test.test',
//     phone: 1234345454,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Test designation',
//     department: 'Test department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC128',
//     firstName: 'Another',
//     lastName: 'Test',
//     email: 'hey@test.test',
//     phone: 257257257,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Another designation',
//     department: 'Another department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC129',
//     firstName: 'Another',
//     lastName: 'Test',
//     email: 'hey@test.test',
//     phone: 257257257,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Another designation',
//     department: 'Another department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
//   {
//     _id: 'ABBC130',
//     firstName: 'Another',
//     lastName: 'Test',
//     email: 'hey@test.test',
//     phone: 257257257,
//     birthDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     joinDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     lastSeen: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     passExpiryDate: 'Sat, 31 Jul 2021 21:00:00 GMT',
//     designation: 'Another designation',
//     department: 'Another department',
//     permissions: initialPermissionValues,
//     documents: [],
//     password: '',
//   },
// ];

export const getUsers =
  (): ThunkAction<Promise<AnyAction>, RootState, unknown, AnyAction> =>
  async dispatch => {
    const users = await stApi.getUsers();
    return dispatch({ type: USERS_GET, payload: { users } });
  };

// Local-only: the API has no create/update/delete endpoints for users (see
// the TODO above), so these thunks mutate the Redux store directly, exactly
// like the original did.

export const createUser =
  (
    data: Partial<User>
  ): ThunkAction<AnyAction, RootState, unknown, AnyAction> =>
  dispatch => {
    const newUser = { ...data, _id: makeId(7) };
    return dispatch({ type: USERS_CREATE, payload: newUser });
  };

export const deleteUser =
  (userId: string): ThunkAction<AnyAction, RootState, unknown, AnyAction> =>
  dispatch => {
    return dispatch({ type: USERS_DELETE, payload: userId });
  };

export const updateUser =
  (
    user: Partial<User> & { _id: string }
  ): ThunkAction<AnyAction, RootState, unknown, AnyAction> =>
  dispatch => {
    return dispatch({ type: USERS_UPDATE, payload: user });
  };
